import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from "react-bootstrap/Button";
import "./index.css";

function ConatctCards() {
    return (
        <section className="ConatctCards-section" id='contact-cards'>
            <Container className="ConatctCards-container">
                <h3 className="ConatctCards-heading">Here For You Every Step of the Way</h3>
                <Row className="ConatctCards-row">
                    <Col lg={6} md={12} sm={12} className="ConatctCards-column1">
                        <div className="ConatctCards-box1">
                            <h4 className="ConatctCards-heading1">Before and During the Loan Process</h4>
                            <p className="ConatctCards-para1"><span className="ConatctCards-span1">Apply Now</span><br />Get TRU Approved and Start Today</p>
                        </div>
                        <Button variant="warning" className="ConatctCards-button1"
                            href="https://www.swmc.com/ApplyNow/?c=evolution" target="_blank"
                            rel="noopener noreferrer"
                        >
                            Get Started
                        </Button>
                        <div className='ConatctCards-column3'>
                            <div className="ConatctCards-box3">
                                <h4 className="ConatctCards-heading3">Check Your Loan Status</h4>
                                <p className="ConatctCards-para3">Online or Contact Your Loan Officer</p>
                                <Button variant="outline-dark" className="ConatctCards-button3"
                                    href="https://www.seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusLogin.jsf?c=evolution" target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Check Online
                                </Button>
                                <p className="ConatctCards-para4">
                                    <span className="ConatctCards-span3">Corporate Office</span><br />
                                    <a href="tel:+15629247884" className="ConatctCards-number">562-924-7884</a><br />
                                    18303 Gridley Rd.,<br />
                                    Cerritos, CA 90703
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={12} sm={12} className="ConatctCards-column2">
                        <div className="ConatctCards-box2">
                            <h4 className="ConatctCards-heading2">After Your Loan Has Closed</h4>
                            <p className="ConatctCards-para2"><span className="ConatctCards-span2">View Your Loan Information</span><br /> Make a Payment, View Statements, and More</p>
                        </div>
                        <Button variant="warning" className="ConatctCards-button2"
                            href="https://sunwestmortgage.myloaninfo.com/loanmanager/login/" target="_blank"
                            rel="noopener noreferrer">
                            Log In
                        </Button>
                        <div className='ConatctCards-column4'>
                            <div className="ConatctCards-box4">
                                <h4 className="ConatctCards-heading4">Servicing Questions?</h4>
                                <p className="ConatctCards-para6">Email or Call Us</p>
                                <Button variant="outline-dark" className="ConatctCards-button4"
                                    onClick={() => window.location.href = 'mailto:customercervice@swmc.com'}
                                    // href="mailto:customercervice@swmc.com" target="_self"
                                    // rel="noopener noreferrer"
                                >
                                    CustomerService@swmc.com
                                </Button>
                                <p className="ConatctCards-para5">
                                    <a href="tel:+18447526996" className="ConatctCards-number2">844-752-6996</a><br />
                                    7 a.m. - 7 p.m. PST
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default ConatctCards;